// extracted by mini-css-extract-plugin
module.exports = {"ql-container":"TextEditor_ql-container__rHt6m","ql-snow":"TextEditor_ql-snow__VDp4A","wrapper":"TextEditor_wrapper__RmnBo"};